export default __webpack_public_path__ + "static/footer-31c72e0f6a25efdac04d7ac5d8a5378a.jpg";